<template>
  <div class="page-content">
    <div class="card">
      <SnackbarPrompt icon="warning" variation="warning">{{
        errorMessage
      }}</SnackbarPrompt>
    </div>
  </div>
</template>
<script>
import SnackbarPrompt from "@/components/SnackbarPrompt.vue";
export default {
  props: {
    errorMessage: String,
  },
  components: {
    SnackbarPrompt,
  },
};
</script>
